import { lazy, Suspense, useState } from 'react';
import { useAuth } from '@/utils/Auth';
import dayjs from 'dayjs';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';

// Lazy load the legal components
const TermsOfService = lazy(() => import('@/components/legal/TermsOfService'));
const PrivacyPolicy = lazy(() => import('@/components/legal/PrivacyPolicy'));

export const Footer = () => {
  const currentYear = dayjs().year();
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const { t } = useTranslation();
  const { user } = useAuth();

  return (
    <>
      <footer className=" flex flex-col gap-2 sm:flex-row py-2 w-full items-center px-4 md:px-6  bg-white text-white">
        <p className="text-xs text-gray-400">
          {' '}
          © {currentYear} VionHR. {t('Footer.Copyright')}.{' '}
        </p>
        <nav className="sm:ml-auto flex gap-4 sm:gap-6 text-gray-400">
          {user && (
            <>
              <button
                className="text-xs hover:underline underline-offset-4"
                onClick={() => setIsTermsOpen(true)}
              >
                {t('Footer.TermsOfService')}
              </button>
              <button
                className="text-xs hover:underline underline-offset-4"
                onClick={() => setIsPrivacyOpen(true)}
              >
                {t('Footer.PrivacyPolicy')}
              </button>
            </>
          )}
        </nav>
      </footer>

      {/* Terms of Service Dialog */}
      <Dialog open={isTermsOpen} onOpenChange={setIsTermsOpen}>
        <DialogContent
          className="max-w-4xl max-h-[80vh] overflow-y-auto"
          aria-describedby=""
        >
          <DialogHeader>
            <DialogTitle>{t('Footer.TermsOfService')}</DialogTitle>
          </DialogHeader>
          <p id="terms-desc" className="sr-only">
            {t(
              'Footer.TermsOfServiceDescription',
              'Пълните условия за използване на VionHR.'
            )}
          </p>
          <Suspense
            fallback={
              <div className="flex justify-center p-8">
                <LoadingSpinner />
              </div>
            }
          >
            <TermsOfService />
          </Suspense>
        </DialogContent>
      </Dialog>

      {/* Privacy Policy Dialog */}
      <Dialog open={isPrivacyOpen} onOpenChange={setIsPrivacyOpen}>
        <DialogContent
          className="max-w-4xl max-h-[80vh] overflow-y-auto"
          aria-describedby=""
        >
          <DialogHeader>
            <DialogTitle> {t('Footer.PrivacyPolicy')}</DialogTitle>
          </DialogHeader>
          <p id="privacy-desc" className="sr-only">
            {t(
              'Footer.PrivacyPolicyDescription',
              'Пълният текст на политиката за лични данни на VionHR.'
            )}
          </p>
          <Suspense
            fallback={
              <div className="flex justify-center p-8">
                <LoadingSpinner />
              </div>
            }
          >
            <PrivacyPolicy />
          </Suspense>
        </DialogContent>
      </Dialog>
    </>
  );
};
